import React, { Component } from 'react';
import PropTypes from 'prop-types'
import getLocaleMessages from '../../utils/localesMessages';
import { submit } from 'redux-form';
import { BTN_FACTORY_FORM } from '../../clientConstants';
import getStore from '../../store/configureStore';
import _get from 'lodash/get';
import { isLoggedInUser } from '../../utils/authUtils';

const {
  unactionable: {
    header,
    msg1,
    msg2,
    msg3,
    tryagain,
    startover
  },
  unavailable,
  close
} = getLocaleMessages('buttons/errors')

const store = getStore();

const RemoteSubmitButton = () =>
	<button
		className="vx_btn vx_btn-primary"
		type="submit"
		onClick={() => store.dispatch(submit(BTN_FACTORY_FORM))}
	>
		{tryagain}
	</button>

export class UnactionableErrorModal extends Component {
	static propTypes = {
		closeModal: PropTypes.func,
		startOver: PropTypes.func,
		error: PropTypes.object
	}

	renderToDefaultPage = () => {
		const isLoggedIn = isLoggedInUser(_get(store.getState(), 'application'));

		if (isLoggedIn) {
			window.location.href = '//www.paypal.com/mep/dashboard';
		} else {
			window.location.href = '//www.paypal.com/us/webapps/mpp/merchant';
		}
	}

	render() {
		const errorName = _get(this.props.error, 'name', '');

		return (
			<div
				className="vx_modal-glimpse vx_modalPrepToOpen error_modal unactionable"
				id="unactionable-error-modal"
				role="dialog"
				aria-describedby="unactionable-error-modal-header"
				tabIndex="0"
				aria-label="Modal Dialog"
			>

				<div className="vx_modal-content">
					{errorName !== 'COUNTRY_NOT_ALLOWED' &&
						<button
							className="vx_modal-dismiss_x-trigger"
							data-modal-id="_demoVxModal-glimpse"
							onClick={this.props.closeModal}
						>
              <span className="vx_a11yText">{close}</span>
						</button>
					}

					<div className="attention">
						<span className="vx_icon vx_icon-attention-large" aria-hidden="true"></span>
					</div>

					{
						errorName === 'COUNTRY_NOT_ALLOWED' ?
						<div className="vx_modal-body">
							<p className="center-text" style={{ fontSize: '30px', lineHeight: '40px' }}>{unavailable.header}</p>

							<button
								className="vx_btn vx_btn-primary"
								type="submit"
								onClick={this.renderToDefaultPage}
							>
								{unavailable.button}
							</button>
						</div> :

						<div>
							<header className="vx_modal-header" id="unactionable-error-modal-header">
								<p>{header}</p>
							</header>

							<div className="vx_modal-body">
								<p className="center-text">{msg1}</p>
								<p className="center-text">{msg2}</p>
								<p className="center-text">{msg3}</p>

								<RemoteSubmitButton />

								<button
									className="vx_btn vx_btn-secondary"
									type="submit"
									onClick={this.props.startOver}
								>
									{startover}
								</button>
							</div>
						</div>
					}

				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./buttons/components/modals/UnactionableErrorModal.js